export enum RatingsEnum {
	"terrible" = 0,
	"bad" = 1,
	"normal" = 2,
	"good" = 3,
	"wonderful" = 4
}
